import React, { Component } from "react";
import TranslatedPage from "../TranslatedPage";
import { Button } from "@blueprintjs/core";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import HusqvarnaLogo from "../../styles/images/logo-husqvarna-white.svg";
import SharinLogo from "../../styles/images/logo-sharin-white.png";
import KreditzLogo from "../../styles/images/logo-kreditz-white.png";
import CreateNewCircleDecorator from "../CreateNewCircleDecorator";

class LandingIhopaBuyBoat extends Component {
  render() {
    return (
      <section className="hero image-hero dark custom-landing buy-boat no-selling-points">
        <div className="main-container">
          <div className="content-wrapper">
            <div className="custom-aligner" />
            <div className="main-hero-copy">
              <div>
                <h1 className="bp3-heading">
                  <TranslatedPage path="home.content_blocks.hero_buy_boat.heading" />
                </h1>
                <h2 className="bp3-heading light opacity90">
                  <TranslatedPage path="home.content_blocks.hero_buy_boat.content" />
                </h2>
              </div>
              <div className="cta-area">
                <CreateNewCircleDecorator empty_circle >
                  <Button
                  className="main-cta"
                  intent="primary">
                    <Translate value="custom_landing.landing_buy_boat.buy_boat" />                
                  </Button>
                </CreateNewCircleDecorator>
                <Button
                className="secondary-cta outline-on-dark"
                intent="primary"
                onClick={this.props.goToProducts}>
                  <Translate value="custom_landing.landing_buy_boat.buy_existing" />                
                </Button>
              </div>
            </div>
            <div className="partner-logos">
              <img src={HusqvarnaLogo} alt="Husqvarna Logo" className="partner-logo husqvarna" />
              <img src={KreditzLogo} alt="Kreditz Logo" className="partner-logo kreditz" />
              {/* <img src={NordeaLogo} alt="Nordea Logo" className="partner-logo nordea" /> */}
              <img src={SharinLogo} alt="Sharin Logo" className="partner-logo sharin" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
const mapStateToProps = state => ({
  locale: state.i18n.locale
});
const mapDispatchToProps = dispatch => ({});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LandingIhopaBuyBoat);
